import React from 'react';
import { AboutUsBody, AboutUsHeader } from './styled';
import VerticalSpacer from '../VerticalSpacer';

const AboutUsAfterItalist = () => (
  <div>
    <AboutUsHeader>After italist</AboutUsHeader>
    <VerticalSpacer height="10px" />
    <AboutUsBody>
      Now, thanks to the success of our direct-to-consumer import model, customers can purchase brand-new, genuine,
      in-season fashion and luxury accessories from Italy’s finest retailers without leaving home.
      <br />
      <br />
      Our platform gives customers access to more than 1,000 international brands and 200,000 luxury items across Italy.
      <br />
      <br />
      And italist offers the best value—up to 30% less than market price—for the same authentic luxury goods you’ll find
      on other sites since the products are being imported directly from Italy.
      <br />
      <br />
      After you purchase an item on italist, one of our partner boutiques in Italy receives your order and prepares the
      product for shipment. From there, italist takes care of everything else. Our team tracks the payment through our
      trusted billing service, handles the import/export process, and oversees the delivery from the Italian boutique to
      your doorstep.
      <VerticalSpacer height="20px" />
    </AboutUsBody>
  </div>
);

export default AboutUsAfterItalist;
